import React, { useState } from 'react';
import { Tabs, Tab, Box, Typography, Paper } from '@mui/material';

import { useTranslation } from 'react-i18next';
import ReviewBySchoolPage from '../checkReviewSchool/ReviewSchoolsPage';
import ReviewPage from '../Review';

/* STRANA ZA PROVERU PREGLEDANIH RADOVA */
/* STRANA GDE SE NALAZE 2 TABA U ZAVINOSTI KOJU PROVERU ZELIMO  ( PO SKOLI/PO RAZREDIMA) */
const VerifyReviews = () => {
  const [activeTab, setActiveTab] = useState(0);
  const { t } = useTranslation();

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box sx={{ width: '100%', padding: '20px' }}>
      {/* Naslov stranice */}
      <Typography
        variant="h4"
        align="center"
        gutterBottom
        sx={{
          fontWeight: 'bold',
          color: '#1976d2',
          marginBottom: '20px'
        }}
      >
        {activeTab === 0 ? t('review.schoolsTitle') : t('review.gradesTitle')}
      </Typography>

      {/* Tab bar */}
      <Paper elevation={3} sx={{ borderRadius: '12px', padding: '10px' }}>
        <Tabs
          value={activeTab}
          onChange={handleChange}
          centered
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          sx={{
            '& .MuiTabs-indicator': {
              backgroundColor: '#1976d2'
            },
            '& .MuiTab-root': {
              textTransform: 'none',
              fontWeight: 'bold',
              fontSize: '16px'
            },
            '& .MuiTab-textColorPrimary.Mui-selected': {
              color: '#1976d2'
            }
          }}
        >
          <Tab label={t('review.schools')} />
          <Tab label={t('review.grades')} />
        </Tabs>
      </Paper>

      {/* Tab content */}
      <Paper
        elevation={4}
        sx={{
          marginTop: '20px',
          padding: '20px',
          borderRadius: '16px',
          minHeight: '60vh',
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)'
        }}
      >
        {activeTab === 0 && <ReviewBySchoolPage />}
        {activeTab === 1 && <ReviewPage />}
      </Paper>
    </Box>
  );
};

export default VerifyReviews;
